import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { map } from 'rxjs/operators';
import { AuthService } from 'src/app/auth/auth.service';
import { ItemPickerModel } from 'src/app/shared/components/item-picker/models/itemPickerModel';
import { CustomView } from 'src/app/shared/components/odata-filter/models/custom-view';
import { ViewContext } from 'src/app/shared/components/odata-filter/models/view-context';
import { TeamQueryModel } from 'src/app/shared/models/team/team-query.model';
import { WidgetInstanceModel } from 'src/app/shared/models/widget.model';
import { CustomViewService } from 'src/app/shared/services/custom-view.service';
import { WidgetsService } from 'src/app/shared/services/widgets.service';
import { TeamFilterService } from 'src/app/teams/teams-home/team-filter.service';
import { UpcomingTeamsService } from './upcoming-teams.service';

@Component({
  selector: 'app-upcoming-teams',
  templateUrl: './upcoming-teams.component.html',
  styleUrls: ['./upcoming-teams.component.scss'],
  standalone: false,
  // Scoped per instance so two Upcoming Teams widgets don't share filter state.
  providers: [UpcomingTeamsService]
})
export class UpcomingTeamsComponent implements OnInit, OnDestroy {
  @Input() widgetInfo: WidgetInstanceModel;
  subscriptions: Subscription[] = [];
  odataResult: TeamQueryModel[] = [];
  loaded = false;
  @Output() addTeam = new EventEmitter();
  private _selectedView: CustomView;
  private _views: CustomView[] = [];
  itemPickerValues: ItemPickerModel[] = [];

  constructor(
    private upcomingTeamsService: UpcomingTeamsService,
    private teamFilterService: TeamFilterService,
    private customViewService: CustomViewService,
    private router: Router,
    private authService: AuthService,
    private widgetsService: WidgetsService
  ) {}

  ngOnInit(): void {
    this.subscriptions.push(
      this.customViewService.customViews
        .pipe(
          map((views) => {
            //get first default team view which is All Active Teams
            if (views) {
              return views.filter((f) => f.viewContext == ViewContext.Teams && !f.isTemporary);
            }
          })
        )
        .subscribe((views) => {
          if (views) {
            this._selectedView =
              views.find((x) => x.id == this.widgetInfo?.settings?.selectedViewId) ?? views[0];
            this._views = views;
            this.itemPickerValues = this._views.map((x) => new ItemPickerModel(x.id, null, x.name));
            this.upcomingTeamsService.applyUpcomingTeamsFilter(this._selectedView);
          }
        }),
      this.upcomingTeamsService.filterResultValues.subscribe((result) => {
        if (result) {
          this.odataResult = result.slice(0, 5);
          this.loaded = true;
        }
      })
    );
  }

  get selectedItemPickerValue(): ItemPickerModel {
    return this.itemPickerValues.find((x) => x.id == this._selectedView.id);
  }
  itemPickerSelect(model: ItemPickerModel) {
    this._selectedView = this._views.find((x) => x.id == model.id);
    this.upcomingTeamsService.applyUpcomingTeamsFilter(this._selectedView);
    this.widgetInfo.settings = {
      ...this.widgetInfo.settings,
      selectedViewId: this._selectedView.id
    };
    this.widgetsService.updateInstanceSettings(this.widgetInfo);
  }

  isManager(): boolean {
    return this.authService.managerLevelAccess;
  }
  goToUpcomingTeams() {
    let view = new CustomView(this._selectedView, true, true);
    this.upcomingTeamsService.addUpcomingTeamsFilterToView(view);
    this.teamFilterService.selectView(view);
    this.router.navigate(['/teams'], {
      queryParams: { orderBy: this.upcomingTeamsService.orderBy[0] }
    });
  }
  goToTeams() {
    this.teamFilterService.selectView(this._selectedView);
    this.router.navigate(['/teams']);
  }
  ngOnDestroy(): void {
    this.subscriptions.forEach((subscription) => subscription.unsubscribe());
  }
}
